import helper from '../lib/helper_lib';

export default class RequestPicture {
  constructor(el) {
    this.el = el;
    this.senderId = this.el.dataset.senderId;
    this.senderName = this.el.dataset.senderName;
    this.reciverID = this.el.dataset.reciverId;
    this.reciverEmi = this.el.dataset.reciverEmi;
    this.reciverName = this.el.dataset.reciverName;
    this.requestDate = this.el.dataset.date;
    this.langRequested = this.el.dataset.langRequested;
    this.slg = this.el.dataset.slg;
    this.spg = this.el.dataset.spg;

    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    checkSendPermissionsSimple(this.reciverID , 'PICTURE_REQUEST')
      .then(permissions => {
        if (permissions.disableOption) {
          this.el.remove();
        }
        if (permissions.checkFailed) {
          this.el.addEventListener('click', () => {
          helper.showMessage(
            'error',
            '#message-box',
            '',
            permissions.errorMessage,
            10000
          );
        });
      } else {
        this.el.addEventListener('click', () => {
          const data = {
            mode: 'send_picture_request',
            senderId: this.senderId,
            senderName: this.senderName,
            reciverEmi: this.reciverEmi,
            reciverID: this.reciverID,
            reciverName: this.reciverName,
            date: this.requestDate,
            slg: this.slg,
            spg: this.spg
          };

          const post = new FormData();

          post.append(
            'message',
            new Blob(
              [
                JSON.stringify({
                  message: '',
                  type: 'PICTURE_REQUEST'
                })
              ],
              {
                type: 'application/json'
              }
            )
          );

          fetch(`/api/v1/public/message-threads/${data.reciverID}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            body: post // body data type must match "Content-Type" header
          }).then(r => {
            let disableButton = true;
            if (disableButton) {
              this.el.setAttribute('disabled', 'disabled');
              // console.log('disable the button', myObj);
              setTimeout(() => {
                this.el.removeAttribute('disabled');
                disableButton = false;
              }, 30000);
            }
            if (r.status !== 'undefined' && r.status == 200) {
              this.el.setAttribute('disabled', 'disabled');
              this.el.classList.remove('btn-success');
              this.el.classList.add('picture_requested');
              this.el.innerHTML = this.langRequested;
              this.el.setAttribute('disabled', 'disabled');
            } else {
              helper.showMessage(
                'error',
                '#message-box',
                '',
                i8n.error.Bulkpost_error,
                10000
              );
            }
          });
        });
      }
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/request_picture.js